/* eslint-disable prefer-arrow/prefer-arrow-functions */
// src/utils/authB2b.js

const isBrowser = () => typeof window !== 'undefined';

export function getB2bToken() {
  if (!isBrowser()) return null;
  
return localStorage.getItem('token_b2b');
}

// 🔓 Décoder un JWT (client uniquement)
export function decodeJwt(token) {
  if (!token) return null;
  if (!isBrowser()) return null; // ✅ SSR-safe (atob n'existe pas)

  try {
    const parts = token.split('.');

    if (parts.length < 2) return null;

    const base64Url = parts[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64.length % 4;

    if (pad) base64 += '='.repeat(4 - pad);

    const json = atob(base64);

    
return JSON.parse(json);
  } catch (e) {
    console.error('Erreur decodeJwt(token_b2b) :', e);
    
return null;
  }
}

// ⏳ Expiration (client uniquement)
export function isTokenExpired(token) {
  if (!token) return true;
  if (!isBrowser()) return false; // ✅ côté serveur on ne force pas l'expiration

  const payload = decodeJwt(token);

  if (!payload || !payload.exp) return true;

  const nowInSeconds = Date.now() / 1000;

  
return payload.exp < nowInSeconds;
}

// 🚪 Logout B2B (client uniquement)
export function logoutB2b() {
  try {
    if (!isBrowser()) return; // ✅ SSR-safe

    localStorage.removeItem('token_b2b');
    localStorage.removeItem('b2bUser');
    localStorage.removeItem('userProfil');
  } catch (e) {
    console.error('Erreur logoutB2b :', e);
  }
}
